import { useState, useEffect } from "react";
import { getData } from '../../utils/apiCalls';
import { tracking } from '../../utils/tracking';
import { Link } from "react-router-dom";
import { Loader } from "../Loader";
import partners from '../../data/sponsors_home.json'

export const SponsorSection = () => {
   const [sponsors, setSponsors] = useState([])
   // const [isLoading, setIsLoading] = useState(true)

   useEffect(() => {
      setSponsors(partners)
      // getData("https://youngstartup.io/api/cwebsite/get_sponsors?event=NYVS24")
      //    .then((data) => setSponsors(data))
      //    .then(() => setIsLoading(false))
   }, [])

   return (
      <div className='sponsors'>
         <h1 >OUR PARTNERS</h1>
         {/* {isLoading && <Loader color='dark2' />} */}
         <main>
            {sponsors.map((sponsor_type, i) => {
               const { name, values } = sponsor_type;
               return (
                  <div className='sponsor' key={i}>
                     <h3>{name.toUpperCase().replace(/_/g, " ")}</h3>
                     <div className='logos'>
                        {values?.map(sponsor => (
                           <div key={sponsor.logo_url} className='logo'
                              onClick={() => tracking(282, sponsor.id)}
                           >
                              <a href={sponsor.website} rel='noreferrer' target='_blank'>
                                 <img src={sponsor.logo_url} alt={`${sponsor.name}, partner logo`} />
                              </a>
                           </div>
                        ))
                        }
                     </div>
                  </div>
               )
            })}
         </main>
         <div className="btn-container">
            <Link to='/partners' className="btn">Become a partner</Link>
         </div>
      </div>
   )
}
